import { render, staticRenderFns } from "./PhonesGridContentEdit.vue?vue&type=template&id=b176b0d2"
import script from "./PhonesGridContentEdit.vue?vue&type=script&lang=ts"
export * from "./PhonesGridContentEdit.vue?vue&type=script&lang=ts"
import style0 from "./PhonesGridContentEdit.vue?vue&type=style&index=0&id=b176b0d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports